import * as React from 'react';
import { FlightLegViewModel } from '../../models/flightleg';
import { withFlightAwareTracking, FlightAwareFlightLeg } from '../../signalr/withflightawaretracking';
import { FlightInfo } from './flightinfo';
import { FlightExpired } from './flightexpired';
import { BaseMap } from '../map/basemap';
import { FlightLeg } from '../map/flightleg';
import { Marker } from '../googlemaps/marker';
import { Animation } from '../googlemaps/util';

interface TrackingMapProps extends FlightLegViewModel, FlightAwareFlightLeg {
    airportImage?: string;
    aircraftImage?: string;
    animation?: Animation;
    children?: never;
}

const trackingMap: React.FC<TrackingMapProps> = props => {

    function renderMap(map: google.maps.Map) {
        return <>
            {props.departureLocation && <Marker map={map} position={props.departureLocation} icon={props.airportImage!} animation={props.animation!} />}
            {props.arrivalLocation && <Marker map={map} position={props.arrivalLocation} icon={props.airportImage!} animation={props.animation!} />}
                <FlightLeg map={map} {...props} />
            </>
    }

    function displayMap() {
        if (props.expired) {
            return (
                <FlightExpired />
            )
        } else {
            return (
                <>
                    <FlightInfo {...props} />
                    <div className="mapContainer">
                        <BaseMap style={{ height: '600px', width: '100%' }}>
                            {renderMap}
                        </BaseMap>
                    </div>    
                </>
            )
        }
    }

    return <>
        {displayMap()}
    </>

}

trackingMap.defaultProps = {
    airportImage: '/img/map/baseline-place-24px.svg',
    aircraftImage: '/img/map/baseline-airplanemode_active-24px.svg',
    animation: Animation.DROP 
}


export const TrackingMap = withFlightAwareTracking(trackingMap);